//bao migrate skip
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import JsManager from "./../factories/js-manager";
import TabPage from "./../../factories/tab-page";
import BaoDialog from "../../factories/bao-dialog";

export interface ChecklistBinding {
    src: string | KnockoutObservable<string>;
    params: any | KnockoutObservable<any>;
    tabPage: TabPage;
    setWidth: string | KnockoutObservable<string>;
    loaded: () => void;
}
(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
            || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }
    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () { callback(currTime + timeToCall); }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
}());
function throttle(type: string, name: string, target?: HTMLElement | Window): Function {
    target = target || window;
    var running = false;
    var func = function () {
        if (running) {
            return;
        }
        running = true;
        requestAnimationFrame(function () {
            if (CustomEvent != undefined) {
                try {
                    target.dispatchEvent(new CustomEvent(name));
                }
                catch (e) {
                    target.dispatchEvent(document.createEvent(name));
                }
            }
            else {
                target.dispatchEvent(new Event(name));
            }
            running = false;
        });
    };
    target.addEventListener(type, func);
    return function () {
        let t: any = target;
        t.removeEventListener(type, func);
    };
}
;
///* init - you can init any event */
//throttle("resize", "optimizedResize");
throttle("resize", "optimizedResize", window);
export class ChecklistComponent {
    constructor(public Element: HTMLElement, public Binding: ChecklistBinding, public ViewModel: any) {
    }
    protected get Url() {
        return ko.unwrap(this.Binding.src);
    }
    protected get UrlData() {
        return ko.unwrap(this.Binding.params);
    }
    protected get TabPage() {
        return ko.unwrap(this.Binding.tabPage);
    }
    protected get SetWidth() {
        return ko.unwrap(this.Binding.setWidth);
    }
    protected get IFrame(): HTMLIFrameElement {
        if (this.$IFrame != null) {
            return this.$IFrame[0] as HTMLIFrameElement;
        }
        return null;
    }
    protected get IFrameDoc(): HTMLDocument {
        if (this.IFrame != null) {
            return this.IFrame.contentDocument;
        }
        return null;
    }
    protected get IFrameBody(): HTMLBodyElement {
        if (this.IFrameDoc != null) {
            return this.IFrameDoc.body as HTMLBodyElement;
        }
        return null;
    }
    protected get IFrameWindow(): Window {
        if (this.IFrame != null) {
            return this.IFrame.contentWindow;
        }
        return null;
    }
    protected $IFrame: JQuery;
    protected MutationObserver: MutationObserver;
    public init() {
        this.TabPage.IsLoading(true);
        let iframeUrl = this.CreateHtmlPath(); 
        this.$IFrame = $('<iframe frameborder="0" scrolling="no" style="background-color: #ffffff; width: 100%;" marginwidth="0" marginheight="0" src="' + iframeUrl + '"></iframe>');
        $(this.Element).append(this.$IFrame);
        this.$IFrame.hide();
        if (this.SetWidth != null) {
            this.ViewModel[this.SetWidth] = () => {
                this.setIFrameSize();
            };
        }
        this.MutationObserver = new MutationObserver((mutations) => {
            this.setIFrameSize();
        });
        this.optimizedResizeHandler = this.setIFrameSize.bind(this);
        window.addEventListener("optimizedResize", this.optimizedResizeHandler);
        this.$IFrame.on("load", () => {
            this.iframeLoad();
        });
        ko.utils.domNodeDisposal.addDisposeCallback(this.Element, () => {
            this.dispose();
        });
    }

    /**
     * Method to create a htmlPath (with params) for "Checkware/Evaluation/LoadHtml" endpoint
     * @returns
     */
    protected CreateHtmlPath(){
        let isNew = false;
        let urlId;
        let iframeUrl = Bao.AbsolutePath + "Checkware/Evaluation/LoadHtml"        
            
        if (this.UrlData.folderStructureChecklistId != undefined) {
            isNew = true;
            urlId = this.UrlData.folderStructureChecklistId;
        }
        else if (this.UrlData.evaluationId) {
            urlId = this.UrlData.evaluationId;
        }

        iframeUrl = iframeUrl + "?isNew=" + isNew;
        if (urlId) {
            iframeUrl = iframeUrl + "&id=" + urlId;
        }
     
        return iframeUrl;
    }   

    protected dispose() {
        clearInterval(this.widthInterval);
        window.removeEventListener("optimizedResize", this.optimizedResizeHandler);
        this.$IFrame.off("load");
        $(this.IFrameWindow).off("hashchange");
        this.IFrame.src = "about:blank";
        this.ViewModel.ChecklistModel = null;
        this.ViewModel.iFrame = null;
        this.IFrameDoc.open();
        this.IFrameDoc.write("");
        this.IFrameDoc.close();
    }
    protected optimizedResizeHandler: () => void;
    protected iframeLoad() {
        this.MutationObserver.observe(this.IFrameBody, { subtree: true, attributes: true, childList: true, characterData: true });
        if (this.isKernelReady()) {
            this.loadKernel().then((hasError) => {
                if (hasError) {
                    this.TabPage.IsLoading(false);
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgChecklistNotLoaded"), "info");
                }

                this.initChecklist();
            });
        }
        else {
            this.initChecklist();
        }
    }
    ;
    protected isKernelReady() {
        return this.getKernelVersion("css") != "" && this.getKernelVersion("js") != "";
    }
    ;
    protected getKernelVersion(kernelmode) {
        var version = $("#kernel" + kernelmode, this.IFrameDoc).attr("data-kernel-version");
        if (version == null) {
            return "";
        }
        return version;
    }
    ;
    protected loadKernel() {
        let cssVersion = this.getKernelVersion("css");
        let jsVersion = this.getKernelVersion("js");
        let jsDef = $.Deferred();
        var srcUrl = Bao.AbsolutePath + "Checkware/Resource/KernelJs?version=" + jsVersion;
        //create iframe on window
        //eval is evil - but we need to use it here - otherwise, the window in the loaded kernel is not the "iframe" window, but the "main checkware" window (we don't know why...)
        let evalString = "var s = document.createElement('script'); s.setAttribute('src', '" + srcUrl + "');";
        evalString = evalString + "s.setAttribute('type', 'text/javascript'); document.body.appendChild(s);";
        this.IFrameWindow["eval"](evalString);

        let hasError = false;
        let intRef = setInterval(() => {
            try {
                if (this.IFrameWindow["__checklistFactory"] != null) {
                    this.IFrameWindow["__checklistFactory"](this.IFrameWindow["__checklistModule"]);
                    clearInterval(intRef);
                    hasError = false;
                    jsDef.resolve();
                }
            }
            catch (ex) {
                console.error(ex);
                clearInterval(intRef);
                hasError = true;
                jsDef.resolve();
            }
        }, 10);

        let resultPromise = $.Deferred<boolean>();

        $.when(Bao.get("Checkware/Resource/KernelCss", { version: cssVersion }, (css) => {
            $("#kernelcss", this.IFrameDoc).html(css);
        }), jsDef.promise()).then(() => {
            resultPromise.resolve(hasError);
        });

        return resultPromise.promise();
    }
    ;
    protected checklistLoaded() {
        if (this.IFrameWindow != null &&
            ((this.IFrameDoc != null && this.IFrameDoc.getElementById('checklist-error-view') != null) ||
            this.IFrameWindow["ChecklistModel"] != null)) {
            return true;
        }
        return false;
    }
    protected waitForChecklistToLoad() {
        let def = $.Deferred();
        if (this.checklistLoaded()) {
            def.resolve();
        }
        else {
            let intRef = setInterval(() => {
                if (this.checklistLoaded()) {
                    clearInterval(intRef);
                    def.resolve();
                }
            }, 50);
        }
        return def.promise();
    }
    protected widthInterval: number = null;
    protected completeInitChecklist(result) {
        ko.map.fromJS(result.Model, this.ViewModel);
        setTimeout(() => {
            this.$IFrame.show();
            this.setIFrameSize();
            //widthInterval = setInterval(calculateWidth, 50);
        }, 1);
        this.IFrameWindow["JsManager"] = new JsManager(this.TabPage);
        $(this.IFrameWindow).on('hashchange', () => {
            var h = this.IFrameWindow.location.hash;
            if (h != null) {
                this.IFrameWindow["JsManager"].DownloadAttachment(h.substr(1));
            }
        });
        this.ViewModel.JsManager = this.IFrameWindow["JsManager"];
        this.ViewModel.ChecklistModel = this.IFrameWindow["ChecklistModel"];
        this.ViewModel.iFrame = this.IFrame;
        this.ViewModel.JsManager.Refresh()
            .then(() => {
                if (this.Binding.loaded != null) {
                    this.Binding.loaded();
                }
            });
        this.widthInterval = window.setInterval(() => {
            this.setIFrameSize();
        }, 5000);
    }
    protected initChecklist() {
        let def = $.Deferred();
        Bao.post(this.Url, JSON.stringify(ko.map.toJS(this.UrlData)), (result) => {
            if (result.Model.CompleteDateHtml != null && result.Model.CompleteDateHtml != "") {
                this.completeInitChecklist(result);
                def.resolve();
            }
            else {
                this.waitForChecklistToLoad().then(() => {
                    this.completeInitChecklist(result);
                    def.resolve();
                });
            }
        });
        return def.promise();
    }
    protected _setIframeSizeTimeout: number = null;
    protected setIFrameSize() {
        if (this._setIframeSizeTimeout != null) {
            clearTimeout(this._setIframeSizeTimeout);
        }
        this._setIframeSizeTimeout = window.setTimeout(() => {
            if (this.IFrameBody != null) {
                if (this.Binding.tabPage.IsActiveTab() && this.IFrameBody.scrollHeight > 0) {
                    this.IFrame.height = this.IFrameBody.scrollHeight + "px";
                }
                this._setIframeSizeTimeout = null;
            }
            //zweiter Timeout, damit langsame Geräte (iOS) etwas Zeit haben, das Bild aufzubauen (bei großen Checklisten)
            window.setTimeout(() => {
                if (this.IFrameBody != null) {
                    if (this.Binding.tabPage.IsActiveTab() && this.IFrameBody.scrollHeight > 0) {
                        this.IFrame.height = this.IFrameBody.scrollHeight + "px";
                    }
                }
            }, 500);
        }, 10);
    }
}
ko.bindingHandlers.checklist = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            let c = new ChecklistComponent(element, valueAccessor(), viewModel);
            c.init();      
    }
};